import './index.scss'
import { __ } from '@wordpress/i18n';
import classnames from 'classnames';

import  ResetAttributes  from '../../../general/ResetButton.js'

import { useState, useEffect } from '@wordpress/element';
import { addFilter } from '@wordpress/hooks';
import { useSelect } from '@wordpress/data';

import { InspectorControls } from '@wordpress/block-editor';
import {	
	PanelBody,	
	TextControl,
	Button,
	RangeControl, 
	ToggleControl,
	CheckboxControl,
	Flex,
	FlexItem,
	ButtonGroup
} from '@wordpress/components';


const allowedBlocks = [ 'core/column' ];
const acolumnDefaults = {
	aOn: false,	
	order: [0, 0, 0],
};

const addAttributes = ( settings, name ) => {		

	if (!allowedBlocks.includes(name)) return settings;	

	if( typeof settings.attributes !== 'undefined' ){	

		settings.attributes = {
      ...settings.attributes,	
			acolumn: {
				type: 'object',
				default: acolumnDefaults,
			},
		}    
	}
	return settings;
}


const addInspectorControl = ( BlockEdit ) => ( props ) => {

	if (!allowedBlocks.includes(props.name)) return <BlockEdit {...props} />;

	const { attributes, setAttributes, isSelected } = props;
	const { acolumn = {} } = attributes;

  const orgDefaults = {
		...acolumnDefaults,
		...(attributes.acolumn || {}),
	}

	const { 
		aOn, 
		order
	} = orgDefaults;
	
	const isDifferentFromDefault = JSON.stringify({ ...acolumn, aOn: undefined }) !== JSON.stringify({ ...acolumnDefaults, aOn: undefined });

	const updateObject = (obj, key, newVal) => ({ ...obj, [key]: newVal });
	const updateArray = (list, index, newVal) => {
		const listsCopy = [...list];
		listsCopy[index] = newVal;
		return listsCopy;
	}

	const reset = () => {
			setAttributes({
				acolumn: {
					...acolumn,
					order: acolumnDefaults.order,					
				},
			});
		};
	
		
		const [syncViewport, setSyncViewport] = useState(false);
		const [breakPoint, setBreakPoint] = useState(0);
	
		useEffect(() => {
			const update = () => {
				let temp = 'Desktop';
				if (breakPoint === 1) temp = 'Tablet';
				if (breakPoint === 2) temp = 'Mobile';
				if (syncViewport) wp.data.dispatch('core/editor').setDeviceType(temp);
			};
			update();
		}, [syncViewport, breakPoint]);
	


	return (
		<>
			<BlockEdit {...props} />

				<InspectorControls group="settings">	

					<PanelBody title={__('Order', 'aver')} initialOpen={ aOn }>

						<Flex direction="column" style={{ marginTop: "1rem", gap: "1rem" }}> 		
							<Flex>
								<FlexItem>
									<ToggleControl
										label={__('Enable Order', 'aver')}
										checked={aOn}
										onChange={(val) => setAttributes({ acolumn: {...acolumn, aOn: val }})}
									/>
								</FlexItem>
								<FlexItem>
									{ isDifferentFromDefault && (
										<ResetAttributes
											onConfirm={() => {
												setAttributes({
													acolumn: acolumnDefaults
												});								
											}}
										/> 
									)}
								</FlexItem>
							</Flex>		

							{ aOn && (<>	

							<Flex>
								<FlexItem className="button-frame">
									<Button icon="welcome-view-site" label="Sync Viewport" onClick={() => setSyncViewport(!syncViewport)}	isPressed={syncViewport} />
									<Button icon="undo"	label="Reset All"	onClick={()=> reset()}	/>
								</FlexItem>
								<FlexItem className="button-frame">
									<Button	icon="desktop" isPressed={breakPoint === 0}	onClick={() => setBreakPoint(0)} label=">1024px" />
									<Button icon="tablet"	isPressed={breakPoint === 1} onClick={() => setBreakPoint(1)}	label="≥782px" />
									<Button	icon="smartphone"	isPressed={breakPoint === 2} onClick={() => setBreakPoint(2)}	label="<782px"/>
								</FlexItem>
							</Flex>		

							<RangeControl
								label={__(`Order[${breakPoint}]`, 'aver')}
								onChange={(newval) =>
									setAttributes({ acolumn: {...acolumn, order: updateArray(order, breakPoint, newval)}})
								}									
								min={0}
								max={10}
								value={order[breakPoint]}
								__nextHasNoMarginBottom={true}
							/>		


							</> )}

						</Flex>

					</PanelBody>			
			</InspectorControls>
		</>
	)

}


const applyExtraClassEditor = ( BlockListBlock ) => ( props ) => {
		
	if (!allowedBlocks.includes(props.name)) return <BlockListBlock {...props} />	

	const { attributes, wrapperProps, className } = props;
	const { acolumn = {} } = attributes;
	const orgDefaults = {
		...acolumnDefaults,
		...(attributes.acolumn || {}),
	}

	const { 
		aOn, 
		order
	} = orgDefaults;
	
	if (!aOn) return <BlockListBlock {...props} />;

	const currentDevice = useSelect((select) => {
		return select( 'core/editor' ).getDeviceType();
	}, []);
	const breakPoint = { Desktop: 0, Tablet: 1, Mobile: 2 }[currentDevice];

	const getFallback = (list, index) => {
		if (list?.[index]) return list[index];
		if (index === 2 && list?.[1] !== '') return list[1];
		if (index === 2 && list?.[0] !== '') return list[0];
		if (index === 1 && list?.[0] !== '') return list[0];
		return '';
	};



	const classes = classnames(
		className, ``, 
		{}
	)
	

	const cssstyle = { 
		...wrapperProps?.style,
		...(getFallback(order, breakPoint) !== '' && { order: getFallback(order, breakPoint) }),			
	}    

	return (
		<BlockListBlock
			{...props		} 
			wrapperProps={ { style : {...cssstyle } } }		
			className= { classes }
		/>
	);
}



addFilter(
	'blocks.registerBlockType',
	'aver/aver-column-attributes',
	addAttributes
)

addFilter(
	'editor.BlockEdit',
	'aver/aver-column-advanced-control',
	addInspectorControl
)

addFilter(
	'editor.BlockListBlock',
	'aver/aver-column-editor-class',
	applyExtraClassEditor,
)